import { useCartStore } from '../../store/useCartStore';

export function useCartNotices() {
  const notices = useCartStore((state) => state.cartNotices);
  const clearNotices = useCartStore((state) => state.clearCartNotices);

  return {
    notices,
    clearNotices
  };
}
